import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import caso from "../caso";
import "./menuAbordajes.scss";
import { cargaAbordaje, updateDataUser } from "../js/actions";

function mapStateToProps(state){
	let ultima_exploracion = (state.login.user && state.login.user.acf && state.login.user.acf.ultima_exploracion)?parseInt(state.login.user.acf.ultima_exploracion):0;
	let soloAtlas = (state.login.user.acf && state.login.user.acf.solo_atlas)?state.login.user.acf.solo_atlas:false;
	return({
		ultima_exploracion: ultima_exploracion,
		token: state.login.token,
		soloAtlas: soloAtlas,
	});
}

function mapDispatchToProps(dispatch) {
	return {
		cargaAbordaje: (caso,abordaje)=> dispatch(cargaAbordaje({caso,abordaje})),
		updateDataUser:(field,value)=>dispatch(updateDataUser({field,value})),
	};
}

function MenuExploracion(props){
	let indexAbs = 0;
	let menu = caso.map((item,index) =>{
		let abordajes = item.abordajes.map((subItem,subIndex)=>{
			let clase = "abordaje";
			if(props.soloAtlas)
				clase += " on";
			if(indexAbs > props.ultima_exploracion)
				clase += " off";
			indexAbs++;
			return <div className={clase} key={"abordaje_"+index+"_"+subIndex} onClick={()=> props.cargaAbordaje(index,subIndex)}>{subItem.titulo}</div>;
		});
		return (
			<>	
				<div key={"grupo_abordajes_"+index} className="grupoAbordajes">{item.titulo}</div>
				{abordajes}
      </>    
		);
	});
	return( <div className="menuAbordajes">
		{menu}         
	</div>);	
}

MenuExploracion.propTypes = {
	ultima_exploracion: PropTypes.number,
	token:PropTypes.string,
	cargaAbordaje: PropTypes.func,
	updateDataUser:PropTypes.func,
	soloAtlas: PropTypes.bool,
};

export default connect(mapStateToProps,mapDispatchToProps)(MenuExploracion);